import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('forms');

// Form permissions - user needs ANY of these to access forms
const formPermissions = [
  'manage_forms',
  'view_form_submissions',
  'create_form_submissions',
];

const formsRoutes = [
  {
    path: '/forms',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: 'forms',
      permissions: formPermissions,
    },
    children: [
      {
        path: '',
        name: 'forms',
        props: true,
        component: loadView('FormCollections'),
        meta: {
          feature: 'forms',
          permissions: formPermissions,
        },
      },
      {
        path: 'collections/:collectionId',
        name: 'collection-detail',
        props: true,
        component: loadView('formCollections/CollectionDetail'),
        meta: {
          feature: 'forms',
          permissions: formPermissions,
        },
      },
      {
        path: ':formId',
        name: 'form-detail',
        props: true,
        component: loadView('forms/FormDetail'),
        meta: {
          feature: 'forms',
          permissions: formPermissions,
        },
      },
    ],
  },
];

export default formsRoutes;
